import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { PagedResult, DeckShape } from '../../models';
import { IBaseService } from '../BaseService';


export interface IDeckShapeService extends IBaseService<DeckShape, number> {
	getMultiple(ids: number[]): Promise<DeckShape[]>;
}


@injectable()
export class DeckShapeService implements IDeckShapeService {

	private cache: Promise<DeckShape[]>;

	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) { }

	public get(id: number): Promise<DeckShape> {
		const url = `${this.settings.baseUrl}${this.settings.deckShapeUrl}/${id}`;
		return this.httpClient.get<DeckShape>(url);
	}

	public getMultiple(ids: number[]): Promise<DeckShape[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckShapeUrl}/multiple/${ids.join(',')}`;
		return this.httpClient.get<DeckShape[]>(url);
	}

	public page(pageIndex: number, pageSize: number): Promise<PagedResult<DeckShape>> {
		const url = `${this.settings.baseUrl}${this.settings.deckShapeUrl}/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<DeckShape>>(url);
	}

	public list(): Promise<DeckShape[]> {
		const url = `${this.settings.baseUrl}${this.settings.deckShapeUrl}`;
		if (!this.cache) { this.cache = this.httpClient.get<DeckShape[]>(url); }
		return this.cache;
	}

	public save(model: DeckShape): Promise<DeckShape> {
		this.cache = null; // INVALIDATE CACHE
		const payload = {
			id: model.id,
			name: model.name,
			description: model.description,
			sortBy: (model.sortBy != null) ? parseInt(model.sortBy.toString(), null) : null,
		};

		let url = `${this.settings.baseUrl}${this.settings.deckShapeUrl}`;
		if (model.id !== null && model.id !== undefined) {
			url += `/${model.id}`;
			return this.httpClient.put(url, payload);
		}
		return this.httpClient.post(url, payload);
	}

	public delete(id: number): Promise<any> {
		this.cache = null; // INVALIDATE CACHE
		const url = `${this.settings.baseUrl}${this.settings.deckShapeUrl}/${id}`;
		return this.httpClient.delete(url);
	}

}
